import clsx from 'clsx';
import { useState } from 'react';
import { Button } from '../../../shared/ui/button/Button';
import { ConfirmDialog } from '../../../shared/ui/confirm-dialog/ConfirmDialog';
import { TEMPLATE_STATUS } from '../../../features/templates/constants/messageTemplateKeys';
import { resolveSaveStatus } from '../../../features/templates/lib/resolveSaveStatus';
import styles from '../EmailTemplateCreatePage.module.css';

export function CreateTemplateActions({
  isEditMode,
  currentStatus,
  isAlreadyPublished,
  onDiscardClick,
  onPreviewOpen,
  submitTemplate,
  deactivateTemplate,
  tryPublish,
  isSaveDisabled,
  isDeactivateDisabled,
  isPublishDisabled,
}) {
  const [publishConfirmOpen, setPublishConfirmOpen] = useState(false);

  const handlePublishClick = () => {
    if (tryPublish?.()) setPublishConfirmOpen(true);
  };

  const isAlreadyInactive = currentStatus === TEMPLATE_STATUS.INACTIVE;
  const showDeactivate = isEditMode && currentStatus != null && !isAlreadyInactive;

  return (
    <div className={clsx(styles.subheaderRight)} aria-label="Actions">
      <ConfirmDialog
        open={publishConfirmOpen}
        onClose={() => setPublishConfirmOpen(false)}
        onConfirm={() => {
          setPublishConfirmOpen(false);
          submitTemplate(TEMPLATE_STATUS.PUBLISHED);
        }}
        title="Publish Template"
        body="Once published, this template will become active immediately and available for use in campaigns. Are you sure you want to continue?"
        confirmLabel="Publish"
        cancelLabel="Cancel"
        confirmVariant="primary"
      />

      {showDeactivate ? (
        <Button
          size="sm"
          variant="outlineDelete"
          type="button"
          onClick={deactivateTemplate}
          disabled={isDeactivateDisabled}
        >
          Deactivate
        </Button>
      ) : null}
      <Button size="sm" variant="outline" type="button" onClick={onDiscardClick}>
        Discard
      </Button>
      <Button size="sm" variant="outline" type="button" onClick={onPreviewOpen}>
        Preview
      </Button>
      {!isAlreadyPublished ? (
        <Button
          size="sm"
          variant="outline"
          type="button"
          onClick={() => submitTemplate(resolveSaveStatus(currentStatus))}
          disabled={isSaveDisabled}
        >
          Save
        </Button>
      ) : null}
      <Button
        size="sm"
        variant="primary"
        type="button"
        onClick={handlePublishClick}
        disabled={isPublishDisabled}
      >
        Publish
      </Button>
    </div>
  );
}
